import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { returnGrops } from "../Hooks/UserHooks";
import './handleLogin.css';

const DkjAiLogo: React.FC = () => (
  <svg width="128" height="32" viewBox="0 0 128 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 0C24.832 0 32 7.168 32 16C32 24.832 24.832 32 16 32C7.168 32 0 24.832 0 16C0 7.168 7.168 0 16 0ZM16 28.8C23.072 28.8 28.8 23.072 28.8 16C28.8 8.928 23.072 3.2 16 3.2C8.928 3.2 3.2 8.928 3.2 16C3.2 23.072 8.928 28.8 16 28.8ZM21.6576 8.08L23.92 10.3424L16 18.2624L13.7376 16L21.6576 8.08Z"
      fill="#0E1F27"
    />
    <path
      d="M120.541 26.3985V8.78445H123.918V26.3985H120.541ZM116.634 26.3985V23.5842H127.163V26.3985H116.634ZM116.634 11.5987V8.78445H123.62V11.5987H116.634ZM120.342 6.23506V2.75861H123.786V6.23506H120.342Z"
      fill="#0E1F27"
    />
    <path
      d="M103.587 26.9904C102.483 26.9904 101.49 26.7918 100.607 26.3944C99.7241 25.9971 99.0178 25.4343 98.4881 24.7059C97.9804 23.9775 97.7266 23.1277 97.7266 22.1565C97.7266 20.6556 98.1791 19.4857 99.084 18.6469C100.011 17.8082 101.402 17.2122 103.256 16.859L108.951 15.6671C108.951 14.2986 108.653 13.2722 108.057 12.588C107.461 11.9037 106.567 11.5616 105.375 11.5616C104.271 11.5616 103.41 11.8154 102.792 12.3231C102.174 12.8308 101.755 13.5371 101.534 14.4421L98.0245 14.2103C98.3556 12.5328 99.1613 11.1753 100.442 10.1379C101.722 9.1005 103.366 8.58179 105.375 8.58179C107.626 8.58179 109.337 9.2219 110.507 10.5021C111.699 11.7823 112.295 13.5481 112.295 15.7996V22.7525C112.295 23.1498 112.383 23.4367 112.559 23.6133C112.736 23.7678 112.99 23.8451 113.321 23.8451H114.314V26.5931C114.182 26.6152 113.961 26.6372 113.652 26.6593C113.365 26.6814 113.078 26.6924 112.791 26.6924C111.997 26.6924 111.323 26.56 110.772 26.2951C110.22 26.0302 109.8 25.6219 109.513 25.0701C109.249 24.4962 109.094 23.7788 109.05 22.918H109.58C109.447 23.6905 109.105 24.3858 108.553 25.0039C108.001 25.6219 107.295 26.1075 106.434 26.4607C105.573 26.8138 104.624 26.9904 103.587 26.9904ZM104.083 24.2424C105.143 24.2424 106.037 24.0547 106.765 23.6795C107.494 23.3043 108.035 22.7745 108.388 22.0903C108.763 21.406 108.951 20.6004 108.951 19.6733V18.3158L104.05 19.3091C102.991 19.5078 102.251 19.8168 101.832 20.2362C101.413 20.6556 101.203 21.2074 101.203 21.8916C101.203 22.62 101.457 23.1939 101.965 23.6133C102.472 24.0327 103.179 24.2424 104.083 24.2424Z"
      fill="#0E1F27"
    />
    <path d="M88.8281 26.5931V22.2227H93.331V26.5931H88.8281Z" fill="#0E1F27" />
    <path
      d="M76.4287 31.5595V28.7453H78.482C79.387 28.7453 80.0492 28.5466 80.4686 28.1493C80.91 27.752 81.1308 27.0236 81.1308 25.9641V8.97915H84.5079V26.1627C84.5079 27.9065 84.0443 29.2419 83.1173 30.1689C82.2123 31.096 80.7886 31.5595 78.8462 31.5595H76.4287ZM76.6936 11.7934V8.97915H82.9518V11.7934H76.6936ZM81.0314 6.42976V2.95331H84.4748V6.42976H81.0314Z"
      fill="#0E1F27"
    />
    <path
      d="M58.3633 26.5931V3.08569H61.7073V17.8523L69.6535 8.9791H73.9245L67.0378 16.4617L74.2225 26.5931H70.2825L64.8195 18.7132L61.7073 21.991V26.5931H58.3633Z"
      fill="#0E1F27"
    />
    <path
      d="M44.4055 26.9904C42.9046 26.9904 41.6023 26.6262 40.4987 25.8978C34.5911 21.8807 36.5455 9.90593 44.4055 9.90593C45.6416 9.90593 46.7232 10.1929 47.6502 10.7668C48.5773 11.3407 49.2505 12.0139 49.6699 12.7864V3.08569H53.0139V26.5931H49.9016L49.8023 23.8782C48.7532 25.9287 46.6633 26.9904 44.4055 26.9904ZM44.9684 23.9113C46.8665 23.9113 48.3554 22.7968 49.0739 21.0639C50.4708 17.8045 49.0202 12.9851 44.9022 12.9851C42.3446 12.9851 40.5649 15.392 40.5649 17.7861C40.5649 20.5796 41.6602 23.9113 44.9684 23.9113Z"
      fill="#0E1F27"
    />
  </svg>
);

const MailIcon: React.FC = () => (
  <svg width="113" height="88" viewBox="0 0 113 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_95_2344)">
      <path d="M27.5773 87.5759L95.9711 61.7275H77.5226H59.762H0.158203L27.5773 87.5759Z" fill="#E1E1E1" />
      <path d="M110.732 78.4864L28.2524 86.7019L19.024 26.8545L18.4531 23.1524L61.3454 1.32458L98.1119 27.05L98.7059 29.4711L110.732 78.4864Z" fill="#FBFBF7" />
      <path d="M28.2524 86.7019L110.732 78.4864M28.2524 86.7019L19.024 26.8545M28.2524 86.7019L61.3454 50.9765M110.732 78.4864L98.7059 29.4711M110.732 78.4864L73.1859 50.7151M98.7059 29.4711L73.1859 50.7151M98.7059 29.4711L98.1119 27.05M73.1859 50.7151L66.3032 45.6242L61.3454 50.9765M19.024 26.8545L61.3454 50.9765M19.024 26.8545L18.4531 23.1524M98.1119 27.05L18.4531 23.1524M98.1119 27.05L61.3454 1.32458L18.4531 23.1524" stroke="#E1E1E1" strokeWidth="1.60976" />
      <path d="M19.0645 22.8577L61.3372 1.45032L97.4316 26.7056L19.0645 22.8577Z" fill="#E1E1E1" />
      <path d="M28.752 84.9757L57.7497 49.063L62.1682 50.8452L28.752 84.9757Z" fill="#E1E1E1" />
    </g>
    <defs>
      <clipPath id="clip0_95_2344">
        <rect width="112.146" height="88" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const HandleLogin: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  const renderStatus = (title: string, description: string, showResend: boolean) => (
    <div className="handleLoginPage">
      <div className="handleLoginLogo" aria-label="dkj.ai">
        <DkjAiLogo />
      </div>

      <div className="handleLoginCard">
        <div className="handleLoginIcon">
          <MailIcon />
        </div>
        <h1 className="handleLoginTitle">{title}</h1>
        <p className="handleLoginDescription">{description}</p>
        {showResend && (
          <p className="handleLoginHint">
            Didn&apos;t get it? <button type="button" onClick={() => navigate('/login')}>Resend</button> or check spam.
          </p>
        )}
      </div>
    </div>
  );

  useEffect(() => {

    const handleHashLogin = async () => {

      const hash = new URLSearchParams(location.search).get('hash');
      if (hash) {
        const decodeHash = JSON.parse(atob(hash));
        const { email, code } = decodeHash || {};

        if (email && code) {
          try {
            const cognitoUser = await Auth.signIn(email);
            if (cognitoUser) {
              submitCode(cognitoUser, code);
            }
          } catch (error: any) {
            console.error(error.message);
            setError(true);  // Set error flag if authentication fails
            setLoading(false); // Stop loading
          }
        } else {
          console.error('This magic link has been used, please request a new magic link.');
          setError(true);  // Set error flag for invalid link
          setLoading(false); // Stop loading
        }
      }
    };

    const submitCode = async (user: any, code: string) => {
      try {
        await Auth.sendCustomChallengeAnswer(user, code);
        const username = String(user?.username || '').trim();
        if (username) {
          localStorage.setItem('userInitials', username.slice(0, 2).toUpperCase());
        }
        if (user) {
          let auth = returnGrops(user);
          if (auth === 'dkj-admin') {
            navigate('/manage');
          } else {
            navigate('/employee');
          }
        }
      } catch (error: any) {
        setError(true); // Set error flag for failed code submission
        setLoading(false); // Stop loading
        localStorage.removeItem('loginRedirect');
        // message.error('Login failed: This link is invalid. Please request a new one');
        
        // Redirect to login page after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    };

    handleHashLogin();
  }, [location.search, navigate]);

  if (loading) {
    return renderStatus('Signing you in...', 'Please wait while we verify your magic link.', true);
  }

  if (error) {
    return renderStatus('Login failed', 'There was an issue with this magic link. You will be redirected shortly.', false);
  }

  return null;  // Return nothing while loading or on success (handled in the navigate callback)
};

export default HandleLogin;
